const typeColors = ["#D781DB","#FBD362","#38BA9B","#377FB6","#F0737C","#F7941D"];
const types = ["conventional","artistic","enterprising","social","realistic","investigative"];

export const typeColor = type => typeColors[types.findIndex(item=>item===type)] || "#000";